const Favorites = (params) => {
  
    return (
        <div className="favorites__wrap">
            Favorites
        </div>
    )
}

export default Favorites;